import { ReactNode } from 'react'
import { Button } from '@systemeio/components'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'

interface UnsubscribeCardProps {
  children: JSX.Element
  onConfirmUnsubscribe: () => void
  isFetching?: boolean
  isSuccess: boolean
}

function UnsubscribeCard({
  children,
  onConfirmUnsubscribe,
  isFetching,
  isSuccess,
}: UnsubscribeCardProps): ReactNode {
  const { t } = useTranslation()

  return (
    <>
      <Image
        src={`${
          isSuccess ? '/images/unsubscription-confirm-page.png' : '/images/unsubscribed.png'
        }`}
        alt={t('unsubscribe_page.unsubscribe.title')}
        height={149}
        width={180}
      />
      <>
        <h1 className="mb-8">{t('unsubscribe_page.unsubscribe.title')}</h1>
        {children}
        <div className="flex w-full justify-center gap-4">
          <Button
            variant="primary"
            className="w-full whitespace-normal"
            isLoading={isFetching}
            onClick={async e => {
              e.preventDefault()
              await onConfirmUnsubscribe()
            }}
            type="submit"
          >
            {t('unsubscribe_page.unsubscribe.confirm')}
          </Button>
        </div>
      </>
    </>
  )
}

export default UnsubscribeCard
